import React from "react";
import { COLORS } from "@/app/common/consts/colors";
import type { IconProps } from "./type";

export default function WalletUnlock({ color = "lightWhite" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9994 6.7761C15.9997 6.85053 16 6.92521 16 7V9H18C19.6569 9 21 10.3431 21 12V19C21 20.6569 19.6569 22 18 22H6C4.34315 22 3 20.6569 3 19V12C3 10.3431 4.34315 9 6 9H14V7C14 6.93902 13.9992 6.87032 13.9983 6.79495C13.9911 6.1635 13.9785 5.064 14.378 4.11277C14.6178 3.54192 15.0139 2.98975 15.6494 2.59065C16.278 2.1959 17.0624 2 18 2C19.1181 2 20.1554 2.29508 20.9126 3.03455C21.6741 3.77814 22 4.82192 22 6C22 6.55228 21.5523 7 21 7C20.4477 7 20 6.55228 20 6C20 5.17808 19.7779 4.72187 19.5153 4.46545C19.2485 4.20492 18.7858 4 18 4C17.3376 4 16.947 4.13744 16.7131 4.28435C16.4861 4.42692 16.3322 4.62474 16.222 4.88723C15.9941 5.42991 15.9967 6.09274 15.9994 6.7761ZM13 14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V14Z"
        fill={COLORS[color]}
      />
    </svg>
  );
}
